class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.summary = this.mainDetailsToggle.querySelector("summary");
    this.content = this.summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  open() {
    if (this.mainDetailsToggle.hasAttribute("open")) return;
    this.mainDetailsToggle.setAttribute("open", "");
    this.summary.setAttribute("aria-expanded", true);
  }

  close() {
    if (!this.mainDetailsToggle.hasAttribute("open")) return;
    this.mainDetailsToggle.removeAttribute("open");
    this.summary.setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.closeTimeout = null;

    this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
    this.addEventListener("mouseleave", this.onMouseLeave.bind(this));
    this.summary.addEventListener("click", this.onSummaryClick.bind(this));
    this.mainDetailsToggle.addEventListener(
      "toggle",
      this.onHeaderToggle.bind(this),
    );
  }

  onMouseEnter() {
    clearTimeout(this.closeTimeout);
    this.open();
  }

  onMouseLeave() {
    this.closeTimeout = setTimeout(() => this.close(), 150);
  }

  onSummaryClick(event) {
    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      event.preventDefault();
    }
  }

  onHeaderToggle() {
    if (!this.header) return;

    if (this.mainDetailsToggle.open) {
      this.header.preventHide = true;

      if (
        document.documentElement.style.getPropertyValue(
          "--header-bottom-position-desktop",
        ) !== ""
      )
        return;

      document.documentElement.style.setProperty(
        "--header-bottom-position-desktop",
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
      );
    } else {
      this.header.preventHide = false;
    }
  }
}

customElements.define("header-menu", HeaderMenu);
